import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-video\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M11.077 4.2v7.6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4.2a1 1 0 0 1 1-1h9.077a1 1 0 0 1 1 1ZM12.448 5.509l2.602-1.691a.615.615 0 0 1 .95.515v7.334a.615.615 0 0 1-.95.515l-2.602-1.691a.308.308 0 0 1-.14-.258V5.767c0-.104.052-.201.14-.258Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol